import React from 'react'
import Modal from 'react-modal'
import Sidebar from '../../containers/SidebarContainer'

// Import Scss
import './UserInfoModal.scss'

// Import Image
import close from '../../images/close.png'

class UserInfoModal extends React.Component {
  componentDidMount() {
    // if sub menu is already opened
    if (this.props.openMobileSubMenu) {
      // close it
      this.props.toggleMobileSubMenu()
    }
  }

  render() {
    let props = this.props
    return (
      <div className="user-info__modal__wrapper">
        <Modal
          isOpen={props.openUserInfoModal}
          onRequestClose={props.toggleUserInfoModal}
          className="user-info__modal"
          overlayClassName="user-info__modal__overlay"
          ariaHideApp={false}
        >
          <div className="user-info__modal__inner">
            <h2 className="user-info__modal__title">MY プロフィール
              <button onClick={props.toggleUserInfoModal} className="user-info__modal__close">
                <img className="user-info__modal__close-image" src={close} alt="login-modal__close"/>
              </button>
            </h2>
            <Sidebar
              {...props}
              isModal={true}
              closeModal={props.toggleUserInfoModal}
            />
          </div>
        </Modal>
      </div>
    )
  }
}

export default UserInfoModal



// WEBPACK FOOTER //
// ./src/components/UserInfoModal/UserInfoModal.js